import {Component, OnInit} from '@angular/core';
import {AppConfig} from "../app.config";
import {HttpService} from "../services/http.service";

@Component({
    selector: 'app-media',
    templateUrl: './media.component.html'
})
export class MediaComponent implements OnInit {
    public questionList: any;
    public mediaFile: any;
    public pressRelease: any = [];
    public author: any = {};
    public lastTwoBooks: any = [];
    public socialList: any = {};
    public link_books: any;
    public templates: any;

    constructor(public http: HttpService) {
        AppConfig.instance.getConfig(link => {
            this.socialList = link;
            this.link_books = link['link_books'];
        });
        AppConfig.instance.getAllTextBlocks(textblocks => {
            this.author = textblocks['author_bio'];
            this.pressRelease = textblocks['press_release'];
        });
    }

    ngOnInit() {
        this.http.get(AppConfig.baseUrlApi + 'questions/api_questions').subscribe(response => {
            this.questionList = response.content;
        }, error => {
            console.log(error);
        });
        this.http.get(AppConfig.baseUrlApi + 'books/api_books_all').subscribe(response => {
            this.lastTwoBooks = response.content.slice(0, 2);
        }, error => {
            console.log(error);
        });
        this.http.get(AppConfig.baseUrlApi + 'gallery/api_albums').subscribe(response => {
            this.templates = response.content;
        }, error => {
            console.log(error);
        });
        this.http.get(AppConfig.baseUrlApi + 'media/api_media/file').subscribe(response => {
            this.mediaFile = response.content;
        }, error => {
            console.log(error);
        });
    }


}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/media/media.component.ts